import ProviderAPI from "../redux/ProviderAPI";

export const getBooking = async (data, token) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "booking/detailBooking",
    data,
    token,
  });
  return result;
};

export const getBookingHistory = async (data) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "booking/bookingHistoryDetail",
    data: data,
    headers: data.token,
  });
  return result;
};

export const createBooking = async (data, token) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "booking/createBooking",
    data,
    token,
  });
  return result;
};

export const login = async (data, token) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "booking/login",
    data,
    token,
  });
  return result;
};

export const cancelBooking = async (data, token) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "booking/cancelBooking",
    data,
    token,
  });
  return result;
};

export const addToWhitelist = async ({ id_sellingPrice, idUserTMY }) => {
  const response = await ProviderAPI({
    type: "POST",
    url: "booking/addToWhitelist",
    data: {
      id_sellingPrice,
      idUserTMY,
    },
  });
  return response;
};

export const getWhitelist = async (data, token) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "booking/getWhitelist",
    data,
    token,
  });
  return result;
};

export const removeFromWhitelist = async ({ id_sellingPrice, idUserTMY }) => {
  const response = await ProviderAPI({
    type: "DELETE",
    url: "booking/removeFromWhitelist",
    data: {
      id_sellingPrice,
      idUserTMY,
    },
  });
  return response;
};

export const getYacht = async (data, token) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "booking/getYacht",
    data,
    token,
  });
  return result;
};

export const updateBookingStatus = async (data, token) => {
  const result = await ProviderAPI({
    type: "PUT",
    url: "booking/updateBookingStatus",
    data,
    token,
  });
  return result;
};

export const updateBookingInfo = async (data, token) => {
  const result = await ProviderAPI({
    type: "PUT",
    url: "booking/updateBookingInfo",
    data,
    token,
  });
  return result;
};

export const addOrUpdateBookCustomerDetail = async (data, token) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "booking/addOrUpdateBookCustomerDetail",
    data,
    token,
  });
  return result;
};

export const createPaymentBill = async (data, token) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "booking/createPaymentBill",
    data,
    token,
  });
  return result;
};

export const getPaymentBooking = async (data, token) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "booking/getPaymentBooking",
    data,
    token,
  });
  return result;
};

export const completeBooking = async (data, token) => {
  const result = await ProviderAPI({
    type: "PUT",
    url: "booking/completeBooking",
    data,
    token,
  });
  return result;
};

export const getBookCustomerDetail = async (data, token) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "booking/getBookCustomerdetail",
    data,
    token,
  });
  return result;
};

export const getAllBooking = async (data, token) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "booking/getBooking",
    data,
    token,
  });
  return result;
};

export const getPaymentBill = async (data, token) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "booking/getPaymentBill",
    data,
    token,
  });
  return result;
};

export const getBookingDetails = async (data, token) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "booking/getBookingDetails",
    data,
    token,
  });
  return result;
};

export const updateContractNo = async (data, token) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "booking/updateContractNo",
    data,
    token,
  });
  return result;
};

export const addReview = async (data, token) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "booking/addReview",
    data,
    token,
  });
  return result;
};

export const getReviews = async (data, token) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "booking/getReviews",
    data,
    token,
  });
  return result;
};

export const sendReviewChat = async (data, token) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "booking/sendReviewChat",
    data,
    token,
  });
  return result;
};

export const getReviewChat = async (data, token) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "booking/getReviewChat",
    data,
    token,
  });
  return result;
};

export const getUnreadReviewChat = async (data, token) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "booking/getUnreadReviewChat",
    data,
    token,
  });

  return result;
};